import CascadeIcon from "assets/CascadeIcon";
import InitativeIcon from "assets/InitiativeIcon";
import KPIIcon from "assets/KPIIcon";
import { ICardElementWithChildren } from "backend/model/model";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useBreadcrumbsElementIconStyles = makeThemedStyles(
  "ElementIcon",
  (theme) => ({
    root: {},
  })
);
/*
height: 2em; width: 2em; margin-right: 1.065em; margin-left: 0.66em; background: rgb(0, 169, 163); -webkit-mask: url("http://localhost:4000/http://localhost:4000/api/files/?file=/icons/navitems/corporate.svg") center center / contain no-repeat;
*/
const ElementIcon = (props: {
  item: ICardElementWithChildren;
  size: number;
}) => {
  const classes = useBreadcrumbsElementIconStyles();
  const { item, size } = props;
  const px = (value: string | number) => `${value}px`;
  if (item.typename === "KPI") {
    return <KPIIcon size={size} />;
  }
  if (item.typename === "Initiative") {
    return <InitativeIcon size={size} />;
  }
  if (item.typename === "Scorecard") {
    return <CascadeIcon size={size} />;
  }
  return <CascadeIcon size={size} />;
};

export default ElementIcon;
